// frontend/src/pages/UploadPage.js
import React, { useState } from "react";
import axios from "axios";
import { Button, Typography, Box } from "@mui/material";
import { toast } from "react-toastify";
import LogoutButton from "../components/LogoutButton";
import UploadToggle from "../components/UploadToggle";
import PageContainer from "./PageContainer";

function DemoUpload() {
  const [file, setFile] = useState(null);
  const [uploadType, setUploadType] = useState("player-averages"); // Default value

  const handleSubmit = () => {
    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);

    // Determine the upload endpoint based on uploadType
    const uploadEndpoint = `/api/upload/${uploadType}`;

    axios
      .post(uploadEndpoint, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        toast.success("File uploaded successfully");
        setFile(null); // Reset file after successful upload
      })
      .catch(() => {
        toast.error("Please try again later");
      });
  };

  return (
    <PageContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "darkblue",
          height: "100vh",
        }}
      >
        <Box sx={{ mt: 8, px: 4 }}>
          <Typography color="white" variant="h4">
            Upload Data
          </Typography>
          <LogoutButton />
          <UploadToggle value={uploadType} onChange={setUploadType} />
          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Choose File
            <input
              type="file"
              hidden
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Button>
          {file && (
            <Typography variant="body1" sx={{ mt: 1, color: "white" }}>
              {file.name}
            </Typography>
          )}
          <Button variant="contained" onClick={handleSubmit} sx={{ mt: 2 }}>
            Upload
          </Button>
        </Box>
      </div>
    </PageContainer>
  );
}

export default DemoUpload;
